import React from 'react';
import PropTypes from 'prop-types';
import {compose, graphql} from 'react-apollo';
import {requireLoggedUser} from "helpers/login";
import Settings from "./Settings";
import Loading from "components/Loading";
import {graphQLErrorProcesor, logGraphQLError} from "helpers/errors";
import {FormattedMessage} from "react-intl";
import {withOperator} from "helpers/operator";

import SettingsQuery from 'gql/userSettings.gql';
import ChangeSettingsMutation from 'gql/changeUserSettings.gql';
import ChangePasswordMutation from 'gql/changeUserPassword.gql';

class SettingsProvider extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        userQuery: PropTypes.object.isRequired,
        changeSettings: PropTypes.func.isRequired,
        changePassword: PropTypes.func.isRequired,
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.changeSettings = this.changeSettings.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    componentWillMount() {
        this.setState({
            settingsProcessing: false,
            passwordProcessing: false,
        });
    }

    changeSettings(model) {
        this.setState({settingsProcessing: true});

        this.props.changeSettings({
            variables: {
                operator: this.props.user.id,
                info: {
                    firstName: model.name,
                    lastName: model.surname,
                    phoneNum: model.phone
                }
            }
        }).then(({data}) => {
            this.setState({
                settingsProcessing: false,
                settingStatus: {
                    type: 'success',
                    message: <FormattedMessage id="settings.success" defaultMessage="Successfully changed"/>
                }
            });
        }).catch(error => {
            logGraphQLError(error);
            if (error.networkError) {
                this.setState({
                    settingsProcessing: false,
                    settingsStatus: {
                        type: 'danger',
                        message: (
                            <FormattedMessage id="error.network" defaultMessage="Could not connect to the server"/>)
                    }
                });
            }
            if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                const err = error.graphQLErrors[0];
                let message;
                switch (err.code) {
                    default:
                        message = err.message;
                }
                this.setState({
                    settingsProcessing: false,
                    settingsStatus: {
                        message: message,
                        type: 'danger'
                    }
                })
            }
        });
    }

    changePassword(model) {
        this.setState({passwordProcessing: true});

        this.props.changePassword({
            variables: {
                operator: this.props.user.id,
                oldPassword: model.oldPassword,
                password: model.password,
            }
        }).then(({data}) => {
            this.setState({
                passwordProcessing: false,
                passwordStatus: {
                    type: 'success',
                    message: <FormattedMessage id="settings.success" defaultMessage="Successfully changed"/>
                }
            });
        }).catch(error => {
            logGraphQLError(error);
            if (error.networkError) {
                this.setState({
                    passwordProcessing: false,
                    passwordStatus: {
                        type: 'danger',
                        message: (
                            <FormattedMessage id="error.network" defaultMessage="Could not connect to the server"/>)
                    }
                });
            }
            if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                const err = error.graphQLErrors[0];
                let message;
                switch (err.code) {
                    default:
                        message = err.message;
                }
                this.setState({
                    passwordProcessing: false,
                    passwordStatus: {
                        message: message,
                        type: 'danger'
                    }
                })
            }
        });
    }

    render() {
        const {userQuery, operator, onLogout, onOnlineChange} = this.props;

        if (userQuery.loading) {
            return <Loading/>
        }

        return (
            <Settings defaultValues={userQuery.user} onChangePasswordSubmit={this.changePassword}
                      onSettingsSubmit={this.changeSettings} changePasswordLoading={this.state.passwordProcessing}
                      settingsLoading={this.state.settingsProcessing} changePasswordStatus={this.state.passwordStatus}
                      settingsStatus={this.state.settingsStatus} onLogout={onLogout} onOnlineChange={onOnlineChange}
                      operator={operator}
            />
        )
    }
}

export default compose(
    requireLoggedUser,
    withOperator,
    graphql(SettingsQuery, {
        name: 'userQuery',
        options: {
            fetchPolicy: 'network-only'
        }
    }),
    graphql(ChangeSettingsMutation, {name: 'changeSettings'}),
    graphql(ChangePasswordMutation, {name: 'changePassword'}),
    graphQLErrorProcesor(['userQuery'])
)(SettingsProvider);


// WEBPACK FOOTER //
// ./src/containers/Settings/index.jsx